import LoginHome from './login-home/login-home';
import HoldingHome from './holding-home/holding-home';
import HomeComponent from './home-component';
import UserHome from './user-home/user-home';

/***
 * The home page, containing links to each of the other pages.
 */
const users = angular
    .module('FacilityData.Home', [
        LoginHome,
        HoldingHome,
        UserHome
    ])
    .component('home', HomeComponent)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.home', {
                url: '/',
                component: 'home'
            });
    })
    .name;

export default users;


// WEBPACK FOOTER //
// ./app/components/home/home.js